import PropTypes from 'prop-types';

import { Box } from '@hivebrite/design-system/Box';

import { useLandingContext } from 'hb-react/frontoffice/apps/LiveFeed/contexts/LandingContext';

import Content from './Content';
import Footer from './Footer';
import Header from './Header';

const Landing = ({
  children,
  commentsEnabled,
  displayTopicName,
  titleDetailsForScreenReader,
  title,
  ...boxProps
}) => {
  const { content, type, hasSocialOptions, hasHeader } = useLandingContext();

  return (
    <Box display="block" data-testid={type} {...boxProps}>
      {hasHeader && (
        <Header
          landingTitle={title}
          titleDetailsForScreenReader={titleDetailsForScreenReader}
          displayTopicName={displayTopicName}
        />
      )}
      {content && <Content content={content} />}

      {children}

      {hasSocialOptions && commentsEnabled && <Footer />}
    </Box>
  );
};

Landing.propTypes = {
  children: PropTypes.node,
  displayTopicName: PropTypes.bool,
  title: PropTypes.string,
};

Landing.defaultProps = {
  commentsEnabled: true,
};

export default Landing;
